export default "__VITE_ASSET__06e728f7__"